import { configureStore, combineReducers } from "@reduxjs/toolkit";
import login from "./login";
import sales from "./sales";
import items from "./items";
import clients from "./clients";
import globalStates from "./GlobalStates";
import cart from "./cart";
import expenses from "./expenses";
import customers from "./customer";
import credits from "./Credit";
import receipts from "./receipts";
import invoice from "./invoice";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
const persistConfig = {
  key: "root",
  version: 1,
  storage,
  blacklist: ["globalStates"],
};

const rootReducer = combineReducers({
  store: login,
  sales,
  items,
  credits,
  clients,
  globalStates,
  cart,
  expenses,
  customers,
  receipts,
  invoice,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});
export let persistor = persistStore(store);
